import { Inject, Injectable } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { AppStatic } from '../_helpers/app-static'

// third-party code most pages don't use, loaded only by the components that need it
// (both used to load on every page from index.html):
// - font awesome kit (~100KB js + css): icons in popups, the cookie consent pages and /repo
// - google sign-in (~100KB gsi script): the login page
@Injectable({ providedIn: 'root' })
export class OnDemandService {

  private loadedScripts = new Set<string>()
  private releaseSocialAuthConfig: () => void

  constructor(@Inject(DOCUMENT) private document: Document) {}

  loadFontAwesome() {
    this.loadScript('https://kit.fontawesome.com/d5d75f8ac4.js')
  }

  // SocialAuthService loads the gsi script as soon as it initializes, which happens at startup
  // (AuthService injects it). it waits for SOCIAL_AUTH_CONFIG when that's a promise, so the
  // config is held back here until loadSocialLogin() is called
  deferSocialAuthConfig<T>(config: T): Promise<T> {
    return new Promise(resolve => this.releaseSocialAuthConfig = () => resolve(config))
  }

  loadSocialLogin() {
    if (AppStatic.isBrowser) this.releaseSocialAuthConfig?.()
  }

  private loadScript(src: string) {
    if (!AppStatic.isBrowser || this.loadedScripts.has(src)) return
    this.loadedScripts.add(src)
    let script = this.document.createElement('script')
    script.src = src
    script.async = true
    script.crossOrigin = 'anonymous'
    this.document.head.appendChild(script)
  }
}
